export const backgroundConstants = {
  FETCH_BACKGROUND: '[Background] Load',
  FETCH_BACKGROUND_SUCCESS: '[Background] Load success',
  FETCH_BACKGROUND_FAILURE: '[Background] Load error'
}
